import React from "react"

const Icon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="120" height="120" viewBox="0 0 120 120" fill="none">
    <g clipPath="url(#clip0_1350_22495)">
      <mask
        id="mask0_1350_22495"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="120"
        height="120"
      >
        <path d="M120 0H0V120H120V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_1350_22495)">
        <path
          d="M60 120C93.137 120 120 93.137 120 60C120 26.863 93.137 0 60 0C26.863 0 0 26.863 0 60C0 93.137 26.863 120 60 120Z"
          fill="#F3FCFA"
        />
        <path
          d="M78 64H42C40.896 64 40 64.896 40 66C40 67.104 40.896 68 42 68H78C79.104 68 80 67.104 80 66C80 64.896 79.104 64 78 64Z"
          fill="#18CE99"
        />
        <path
          d="M47.4603 41.395L54.2253 48.159C54.6163 48.55 55.1273 48.745 55.6393 48.745C56.1513 48.745 56.6623 48.55 57.0533 48.159L70.7983 34.415C71.5793 33.634 71.5793 32.368 70.7983 31.587C70.0173 30.806 68.7503 30.806 67.9703 31.587L55.6393 43.917L50.2883 38.567C49.5073 37.786 48.2413 37.786 47.4593 38.567C46.6783 39.348 46.6793 40.615 47.4603 41.395Z"
          fill="#18CE99"
        />
        <path
          d="M85 26H74.259C70.628 22.302 65.58 20 60 20C54.42 20 49.373 22.302 45.741 26H35C31.691 26 29 28.691 29 32V88C29 91.309 31.691 94 35 94H85C88.309 94 91 91.309 91 88V32C91 28.691 88.309 26 85 26ZM60 24C68.822 24 76 31.178 76 40C76 48.822 68.822 56 60 56C51.178 56 44 48.822 44 40C44 31.178 51.178 24 60 24ZM87 88C87 89.103 86.103 90 85 90H35C33.897 90 33 89.103 33 88V32C33 30.897 33.897 30 35 30H42.706C40.996 32.946 40 36.355 40 40C40 51.028 48.972 60 60 60C71.028 60 80 51.028 80 40C80 36.355 79.004 32.946 77.294 30H85C86.103 30 87 30.897 87 32V88Z"
          fill="#18CE99"
        />
        <path
          d="M74 72H46C44.896 72 44 72.896 44 74C44 75.104 44.896 76 46 76H74C75.104 76 76 75.104 76 74C76 72.896 75.104 72 74 72Z"
          fill="#18CE99"
        />
        <path
          d="M70 80H50C48.896 80 48 80.896 48 82C48 83.104 48.896 84 50 84H70C71.104 84 72 83.104 72 82C72 80.896 71.104 80 70 80Z"
          fill="#18CE99"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1350_22495">
        <rect width="120" height="120" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export default Icon
